import React, { useContext, useEffect, useState } from "react";

import { UserContext } from "../login/LoginForm";
import { AuthContext } from "../login/AuthContext";
import { useTranslation } from "react-i18next";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import translations from "../../utils/language/translations.json";
import PcComponent from "./PcComponent";
import FeedbackBoard from "./FeedbackBoard";
import FeedBackTest from "./FeedBackTest";

import ContactNowButton from "../UsefulComponent/ContactNowButton";
import { useFavorites } from "../Favorite/FavoriteProvider";
import { getCountryCode } from "../UsefulComponent/CountryMapping";
import { Description } from "@mui/icons-material";
import ReportFromFullPageListing from "../reportForm/ReportFromFullPageListing";
const regex = {
  // Your regex patterns...
};

// const ViewUserProfil = ({ userData,userFeedback }) => {
//   const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
//   const currentLang = i18n.language; // Access the current language
//   const t = (key) => translations.ViewUserProfil[key][currentLang]; // Adjust the path according to your JSON structure
//   const {userId,loading,liveCsrfToken} = useContext(AuthContext);
//   const [errorMessage, setErrorMessage] = useState("");

//   const { favoriteSellers,
//     favoriteCards,
//     setFavoriteCards,
//     addFavoriteSeller,
//     removeFavoriteSeller,
//     addFavoriteCard,
//     removeFavoriteCard} = useFavorites();
//  let isFavorite = userId && favoriteSellers.some(fav => parseInt(fav.sellerId) === parseInt(userData.thisUserId));

//   const navigate = useNavigate();
//   const { userName } = useParams(); // Get the id from the URL

//   const [formData, setFormData] = useState({
//     Description:userData.Description,
//     thisUserId:userData.thisUserId,
//     ShowName: userName,
//     City: userData.City,
//     State: userData.State,
//     Country: userData.Country,
//     CountryCode:getCountryCode(userData.Country||'canada') || 'CA',
//     EbayProfile: userData.EbayProfile,
//     FacebookProfile: userData.FacebookProfile,
//     ComCProfile: userData.ComCProfile,
//     EpackProfile: userData.EpackProfile,
//     TwitterProfile: userData.TwitterProfile,
//     InstagramProfile: userData.InstagramProfile,
//     ZipCode: userData.ZipCode,
//     ProfilePicture: userData.ProfilePicture,



//     //FeedBack
//     NumberOfTransactions : userData.NumberOfTransactions,
//     AverageRating  : userData.AverageRating
//   });
//   console.log('userData',userData)
//   useEffect(() => {
//     if (!loading) {
//       setFormData(userData);
//     }
   
//   }, [loading, userId, navigate, userName, userData]);


//    const heartIconFull =()=>{

//     return (  <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width={30}
//       height={30}
//       fill="none"
//       viewBox="0 0 16 16"
//     >
//       <path
//         fill="#0066FFED"
//         d="M1.243 8.243 8 15l6.757-6.757a4.243 4.243 0 0 0 1.243-3v-.19A4.052 4.052 0 0 0 8.783 2.52L8 3.5l-.783-.98A4.052 4.052 0 0 0 0 5.053v.19c0 1.126.447 2.205 1.243 3Z"
//       />
//     </svg>)
//    }

//    const heartIconBreak =()=>{
//     return (
//       <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width={25}
//       height={25}
//       fill="none"
//       stroke="#fff"
//       viewBox="0 0 16 16"
  
//     >
//       <path
//         fill="#fff"
//         d="M1.243 8.243 8 15l6.757-6.757a4.243 4.243 0 0 0 1.243-3v-.19A4.052 4.052 0 0 0 8.783 2.52L8 3.5l-.783-.98A4.052 4.052 0 0 0 0 5.053v.19c0 1.126.447 2.205 1.243 3Z"
//       />
//     </svg>
//     )
//    }

//   if (formData === null) {
//     return <div>Loading...</div>;
//   } else {
//     return (
//       <section className="grid" >
//         <div className="contentfront" style={{borderBottom: '5px solid white',paddingBottom: '10px',marginBottom: '20px',boxShadow: '0px 2px 8px rgba(255, 255, 255, 0.3)'}}>
//           <div className="justify top-page">
//             {/* <h3>{t("user-Profil")}</h3> */}
//           </div>
  
//           {/* Profile Section */}
       
//           <div className="profile-container">
//   {/* Left Section: Profile Details */}
//   <div className="left-section-profil">
//     <img 
//       src={formData.ProfilPicture || "/default-avatar.png"} 
//       alt="Profile" 
//       className="profile-picture-view"
//     />
//     <div className="profile-info">
//       <div className="seller-details">
//         <h3 className="seller-name">{formData.ShowName}</h3>
//         <h5 className="seller-rating">({formData.NumberOfTransactions}) {formData.AverageRating * 20}%</h5>

//         {/* Country Flag */}
        
//           <img 
//             src={`https://flagcdn.com/w40/${(formData.CountryCode || 'CA').toLowerCase()}.png`} 
//             alt="flag" 
//             className="country-flag"
//           />
     
//       </div>
//       {parseInt(userId) !== parseInt(formData.thisUserId) && (
//       <ReportFromFullPageListing
//                 userId={userId}
//                 //Data={selectedCard}
//                 liveCsrfToken={liveCsrfToken}
//                 context={'user'}
//               />)}
//       <div className="seller-actions">
        
//   {parseInt(userId) !== parseInt(formData.thisUserId) && (
//     <>
//       {isFavorite ? (
//         <button onClick={() => removeFavoriteSeller(formData.thisUserId)} className="favorite-btn">
//           {t("RemoveFromFavorites")} {heartIconFull()}
//         </button>
//       ) : (
//         <button onClick={() => addFavoriteSeller(formData.thisUserId)} className="favorite-btn">
//           {t("AddToFavorites")} {heartIconBreak()}
//         </button>
//       )}
//       <ContactNowButton targetUserId={formData.thisUserId} targetShowName={formData.ShowName} t={t} />
//     </>
//   )}
// </div>
//       {/* Location */}
       
//         <h5 className="seller-location">
//           { formData.City}{formData.City&& ", "}{formData.State}{formData.Country}
//         </h5>
      

//       {/* Social Media Links */}
//       <div className="social-media-links">
//         {formData.EbayProfile !== "" && (
//           <p><a href={formData.EbayProfile} target="_blank">Ebay</a></p>
//         )}
//         {formData.FacebookProfile !== "" && (
//           <p><a href={formData.FacebookProfile} target="_blank">Facebook</a></p>
//         )}
//         {formData.TwitterProfile !== "" && (
//           <p><a href={formData.TwitterProfile} target="_blank">Twitter</a></p>
//         )}
//       </div>

//       {/* Description */}
//       <h4>{t("Description")}</h4>
//       <p>
//         {userData.Description 
//           ? userData.Description.length > 300 
//             ? `${userData.Description.substring(0, 300)}...` 
//             : userData.Description
//           : t("No description provided")}
//       </p>
//     </div>
//   </div>

//   {/* Middle Section: PC Section */}
//   <div className="pc-container">
//     <PcComponent userId={userId} id={formData.thisUserId} />
//   </div>

//   {/* Right Section: Feedback */}
//   <div className="right-section-profil">
//     <FeedbackBoard userFeedback={userFeedback} />
//   </div>
// </div>
// </div>
//       </section>

//     );
//   };
// }

// ...imports stay as-is

const ViewUserProfil = ({ userData, userFeedback }) => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.ViewUserProfil?.[key]?.[currentLang] ?? key;

  const { userId, loading, liveCsrfToken } = useContext(AuthContext);
  const { favoriteSellers, addFavoriteSeller, removeFavoriteSeller } = useFavorites();
  const isFavorite =
    userId && favoriteSellers.some((f) => Number(f.sellerId) === Number(userData.thisUserId));

  const navigate = useNavigate();
  const { userName } = useParams();

  const [formData, setFormData] = useState(userData || null);
  const [descExpanded, setDescExpanded] = useState(false);

  useEffect(() => {
    if (!loading) setFormData(userData);
  }, [loading, userData]);

  if (!formData) return <div>{t("Loading...")}</div>;

  // helpers
  const ratingPct = formData.AverageRating ? (formData.AverageRating * 20).toFixed(1) : "0.0";
  const txCount = Number(formData.NumberOfTransactions) || 0;
  const safeCountryCode = String(formData.CountryCode || "CA").toLowerCase();
  const locationParts = [formData.City, formData.State, formData.Country].filter(Boolean);
  const locationText = locationParts.join(", ");


  
  const decodeHtmlLite = (s = "") => s.replace(/&amp;/g, "&");

  return (
      <section className="grid" >
        <div className="contentfront" style={{borderBottom: '5px solid white',paddingBottom: '10px',marginBottom: '20px',boxShadow: '0px 2px 8px rgba(255, 255, 255, 0.3)'}}>
        
    <div className="profile-grid">
      {/* LEFT: Profile */}
      <div className="panel panel--left">
        <div className="profile-header">
          
          <div className="avatar-wrap">
            <img
              src={formData.ProfilPicture || "/default-avatar.png"}
              alt={formData.ShowName || "Profile"}
              className="avatar"
            />
            <span className="avatar-ring" />
          </div>

          <div className="seller-line">
            <div className="seller-line-top">
              
              <h3 className="seller-name">{formData.ShowName}</h3>
                <span className="seller-rating">
                {ratingPct}% ({txCount})
              </span>
              <img
                className="country-flag"
                src={`https://flagcdn.com/w40/${safeCountryCode}.png`}
                alt={formData.Country || "Country"}
                loading="lazy"
              />
                      <span className="meta-dot">{t("(2)") /* placeholder key safe */}</span>
            
            </div>
            <div className="seller-meta">
      
    {/* Socials */}
        <div className="chips-row socials">
          {formData.EbayProfile && (
            <a
              href={formData.EbayProfile}
              target="_blank"
              rel="noopener noreferrer"
              className="chip BaseBlack chip--link"
            >
              eBay
            </a>
          )}
          {formData.FacebookProfile && (
            <a
              href={formData.FacebookProfile}
              target="_blank"
              rel="noopener noreferrer"
              className="chip BaseBlack chip--link"
            >
              Facebook
            </a>
          )}
          {formData.TwitterProfile && (
            <a
              href={formData.TwitterProfile}
              target="_blank"
              rel="noopener noreferrer"
              className="chip BaseBlack chip--link"
            >
              Twitter/X
            </a>
          )}
          {formData.InstagramProfile && (
            <a
              href={formData.InstagramProfile}
              target="_blank"
              rel="noopener noreferrer"
              className="chip chip--link"
            >
              Instagram
            </a>
          )}
        </div>

            </div>
          </div>
        </div>

        {Number(userId) !== Number(formData.thisUserId) && (
          <div className="seller-actions">
            {isFavorite ? (
              <button
                className="pill-btn pill-btn--solid"
                onClick={() => removeFavoriteSeller(formData.thisUserId)}
              >
                {t("RemoveFromFavorites")}
                <span className="pill-icon">{/* filled heart svg */}</span>
              </button>
            ) : (
              <button
                className="pill-btn pill-btn--ghost"
                onClick={() => addFavoriteSeller(formData.thisUserId)}
              >
                {t("AddToFavorites")}
                <span className="pill-icon">{/* line heart svg */}</span>
              </button>
            )}
            <ContactNowButton
              targetUserId={formData.thisUserId}
              targetShowName={formData.ShowName}
              t={t}
            />
            <ReportFromFullPageListing
              userId={userId}
              liveCsrfToken={liveCsrfToken}
              context={"user"}
            />
          </div>
        )}

{!!locationText && (
  <div className="chips-row">
    <span className="chip chip--location">
      <svg className="chip-ico" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2a7 7 0 0 0-7 7c0 4.6 6.2 11 6.5 11.3a1 1 0 0 0 1.1 0C12.8 20.9 19 13.6 19 9a7 7 0 0 0-7-7zm0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
      </svg>
      {locationText}
    </span>
  </div>
)}

    

        {/* Description */}
        <div className="form-group">
          <h4 className="section-title">{t("Description")}</h4>
        <p className={`desc ${descExpanded ? "is-open" : ""}`}>
  {(formData?.Description && formData.Description.replace?.(/&amp;/g, "&")) || t("No description provided")}
</p>

          {formData?.Description && formData?.Description.length > 300 && (
            <button className="link-cta" onClick={() => setDescExpanded((s) => !s)}>
              {descExpanded ? t("Show less") : t("Show more")}
            </button>
          )}
        </div>
      </div>

      {/* MIDDLE: PC */}
      <div className="panel panel--middle">
        <div className="panel-header">
          <h3 className="panel-title">{t("PC List")}</h3>
        </div>
        <PcComponent userId={userId} id={formData.thisUserId} />
      </div>

      {/* RIGHT: Feedback */}
      <div className="panel panel--right">
        <div className="panel-header">
          <h3 className="panel-title">{t("All feedback")}</h3>
        </div>
        <FeedbackBoard userFeedback={userFeedback} />
      </div>
      </div>
      </div>
    </section>
  );
};

;

  export default ViewUserProfil;